import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/MainMenuDrawer.css";
import logo from "../../assets/konteyner_logo.png";
import LanguageSwitcher from "./LanguageSwitcher";

const ANIM_MS = 450;

export default function MainMenuDrawer({ chatId = "", open, onClose }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return;
    }
    if (mounted) {
      setClosing(true);
      const tmr = setTimeout(() => {
        setMounted(false);
        setClosing(false);
      }, ANIM_MS);
      return () => clearTimeout(tmr);
    }
  }, [open, mounted]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    if (mounted) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [mounted, onClose]);

  if (!mounted) return null;

  function go(path) {
  onClose?.();

  if (chatId) {
    navigate(path, {
      state: {
        fromChatId: chatId,
        reopenMainMenuOnBack: true,
      },
    });
    return;
  }

  navigate(path, {
    state: {
      reopenMainMenuOnBack: true,
    },
  });
}

  return (
    <div
      className={`mmOverlay ${open && !closing ? "isOpen" : "isClosing"}`}
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <aside className="mmDrawer" onClick={(e) => e.stopPropagation()}>
        <header className="mmHeader">
          <img src={logo} alt="rhode" className="mmLogo" />

          <button
            className="mmCloseBtn"
            onClick={onClose}
            aria-label={t("menu.close")}
          >
            <FiX className="mmCloseIcon" />
          </button>
        </header>

        <div className="mmList">
          <button className="mmItem" onClick={() => go("/about")}>
            {t("menu.about")}
          </button>

          <button className="mmItem" onClick={() => go("/shipping")}>
            {t("menu.shipping")}
          </button>

          <button className="mmItem" onClick={() => go("/privacy")}>
            {t("menu.privacy")}
          </button>

          <button className="mmItem" onClick={() => go("/news")}>
            {t("menu.news")}
          </button>

          <button className="mmItem" onClick={() => go("/contacts")}>
            {t("menu.contacts")}
          </button>
        </div>

        <LanguageSwitcher />
      </aside>
    </div>
  );
}